import { render } from "./profile.vue?vue&type=template&id=40bbbea2&scoped=true"
import script from "./profile.vue?vue&type=script&lang=js"
export * from "./profile.vue?vue&type=script&lang=js"

import "./profile.vue?vue&type=style&index=0&id=40bbbea2&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src384613071/src/admin-ui-svc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40bbbea2"]])

export default __exports__